import React from 'react';
import Loading from './Loading';

export default class NetworkStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  componentWillMount() {
    window.NetworkStatus = this;
  }

  componentWillUnmount() {
    delete window.NetworkStatus;
  }

  showError() {
    this.setState({ show: true });
  }

  hideError() {
    this.setState({ show: false });
  }

  render() {
    const locale = global.dictionaries.calling;
    if (this.state.show === true) {
      return (
        <div className="modal is-active">
          <div className="modal-background" />
          <div className="modal-content">
            <div className="network-status">
              <article className="message is-danger">
                <div className="message-body">
                  <Loading />
                  <p>{locale.reconnectionTry}</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/NetworkStatus.js